import { getImage } from "js/utilities";
import { Link } from "react-router-dom";
import config from "config/config";
import { isAgentPortal } from "js/utilities";
export default function ChatOfflineWindow({ setOpenChatWindow }) {
  return (
    <div className="ui-card fixed bottom-2 right-6 block shadow-sm rounded-lg z-[500] w-[300px] lg:w-[400px]">
      <div className="h-14 flex justify-between items-center text-lg rounded-t-lg bg-ui-red text-white">
        <div className="flex flex-row px-4">
          {config.COMPANY_NAME === "everlake" && (
            <img
              className="w-7 h-7 mr-2"
              src={getImage("symbol_white.png")}
              alt="Everlake logo white"
            />
          )}

          <h3 className="font-semibold">Chat is Offline</h3>
        </div>
        <div className="px-2">
          <button
            className="hover:bg-white/30 hover:rounded-lg p-2"
            aria-label="Minimize chat window"
            onClick={() => setOpenChatWindow(false)}
          >
            <svg
              className="ui-icon h-5 w-5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-minus"></use>
            </svg>
          </button>
          <button
            className="hover:bg-white/30 hover:rounded-lg p-2 ml-0"
            aria-label="Close chat window"
            onClick={() => setOpenChatWindow(false)}
          >
            <svg
              className="ui-icon h-5 w-5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
        </div>
      </div>
      <div className="p-6 lg:p-10 text-center">
        <h3 className="font-semibold">
          Thank you for contacting {config.COMPANY_NAME_TITLE}!
        </h3>
        <br />
        <h3>Chat support is not available right now.</h3>
        <br />
        <h3>
          We’re happy to handle your request during our normal chat hours:
        </h3>
        <br />

        <h3 className="font-semibold">Mon-Fri: 8am-6pm Central Time</h3>
        {isAgentPortal() && (
          <h3 className="font-semibold">Sat: 9am-1pm Central Time</h3>
        )}
        <br />
        <h3>
          In the meantime, please check out our Help section and FAQs for common
          questions and support needs
          <Link to="/help"> here</Link>.
        </h3>
        <button
          className="ui-btn-primary-error w-full h-10 mt-20 ml-0"
          onClick={() => setOpenChatWindow(false)}
        >
          Close chat
        </button>
      </div>
    </div>
  );
}
